export const SEARCH_PARAM_KEYS = {
  MAIN_GALLERY: "gallery",
} as const;
